module.exports = "<footer class=\"footer\">\n  <div class=\"container-fluid\">\n    <nav>\n      <ul>\n        <li>\n          <!-- <a href=\"#\">\n            About Us\n          </a> -->\n        </li>\n      </ul>\n    </nav>\n    <div class=\"copyright\">\n      &copy;\n      {{test | date: 'yyyy'}} &nbsp;\n      <a href=\"https://www.bludottechnologies.com/\" target=\"_blank\">Bludot Technologies</a>\n    </div>\n  </div>\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.html
// module id = ./src/app/components/footer/footer.component.html
// module chunks = main